/* @flow */
import * as React from "react";
import {
  withColorsProvider,
  type ColorSet,
} from "nx-components/ColorsProvider";
import prefixStyles from "nx-components/utils/prefixStyles";
import { IconThinArrowDown } from "nx-components/Icons";
import DOMEventListener from "nexia_mobile/components/DOMEventListener";

type Props = {
  target: HTMLElement | void,
  disabled?: ?boolean,
  activationThreshold: number,
  onActivate?: ?() => void,
  colors: ColorSet,
};

type State = {
  flipped: boolean,
};

class PullToRefreshOffstageIndicator extends React.Component<Props, State> {
  state = {
    flipped: false,
  };

  _onTouchEnd = () => {
    const { disabled, onActivate } = this.props;
    if (disabled) {
      return;
    }

    if (onActivate != null && this._beyondThreshold()) {
      onActivate();
    }

    this.setState({ flipped: false });
  };

  _onScroll = () => {
    if (this.props.disabled) {
      return;
    }

    this.setState({
      flipped: this._beyondThreshold(),
    });
  };

  _beyondThreshold() {
    const { target, activationThreshold } = this.props;
    if (target == null) {
      return false;
    }
    return target.scrollTop < 0 - activationThreshold;
  }

  render() {
    const { target, disabled, colors } = this.props;
    const { flipped } = this.state;

    const styles = prefixStyles({
      wrapper: {
        marginTop: "-2em",
        lineHeight: "2em",
        fontSize: "1.5em",
        color: colors.TITLE,
        textAlign: "center",

        // Prevents iOS Safari from not drawing this element (as an optimization
        // since it's off-screen).
        transform: "translate3d(0, 0, 0)",
      },
      indicator: {
        transition: "transform 0.3s, opacity 0.1s",
      },
    });

    return (
      <div
        data-component-name="PullToRefreshOffstageIndicator"
        style={styles.wrapper}
      >
        <DOMEventListener
          target={target}
          eventName="touchend"
          handler={this._onTouchEnd}
        />
        <DOMEventListener
          target={target}
          eventName="scroll"
          handler={this._onScroll}
        />
        <IconThinArrowDown
          style={{
            ...styles.indicator,
            transform: `rotate3d(0, 0, 1, ${
              // We use 180.1 here instead of 180 because with 180, it's
              // indeterminate whether the browser will decide to transition it
              // clockwise or counter-clickwise towards 180 degrees (and in
              // practice, it flips back and forth). With 180.1, it will
              // (almost) always go the same way.
              flipped ? "180.1deg" : "0deg"
            })`,
            opacity: disabled ? "0.0" : "1.0",
          }}
        />
      </div>
    );
  }
}

export default withColorsProvider(PullToRefreshOffstageIndicator);



// WEBPACK FOOTER //
// ./src/components/PullToRefresh/PullToRefreshOffstageIndicator.jsx